module.exports = __webpack_public_path__ + "img/10972@3x.e43cea22.png";